import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {manifest} from '@/constant/env';

import zhTW from './lang/zh-TW.json';
import zhHK from './lang/zh-HK.json';
import enUS from './lang/en-US.json';
import zhCN from './lang/zh-CN.json';

import getProvinceId from '@/lib/base/getProvinceId';
import {PROVINCE, PROVINCE_LOCALE} from '@/constant/province.js';

Vue.use(VueI18n);

const locale = manifest.default_locale;

const provinceId = getProvinceId();

const provinceLocale = (PROVINCE[provinceId] || PROVINCE_LOCALE.DEFAULT).value;

const i18n = new VueI18n({
  locale: provinceLocale || locale, // set locale
  messages: {tw: zhTW, us: enUS, hk: zhHK, my: zhCN, pl: enUS, kg: enUS}, // set locale messages
});

i18n.localeMapForDayjs = Object.freeze({
  tw: 'zh-tw',
  us: 'en-us',
});

export default i18n;
